import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  blob: {},
  isLoading: false,
  successMessage: undefined,
  errorMessage: undefined,
};

const drmCeaProfileDownloadSlice = createSlice({
  name: "drmCeaProfileDownload",
  initialState,
  reducers: {
    downloadCeaProfileFilesStart: (state) => {
      state.isLoading = true;
      state.successMessage = undefined;
      state.errorMessage = undefined;
    },
    downloadCeaProfileFilesSuccess: (state, action) => {
      state.blob = action.payload.data;
      state.isLoading = false;
      state.successMessage = action.payload.message;
    },
    downloadCeaProfileFilesFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetCeaProfileDownloadState: () => ({ ...initialState }),
  },
});

export const {
  downloadCeaProfileFilesStart,
  downloadCeaProfileFilesSuccess,
  downloadCeaProfileFilesFailure,
  resetCeaProfileDownloadState,
} = drmCeaProfileDownloadSlice.actions;

export default drmCeaProfileDownloadSlice.reducer;
